import * as React from 'react';
import {
    ArrayField,
    Datagrid,
    Edit,
    NumberInput,
    BooleanInput,
    ReferenceInput,
    AutocompleteInput,
    ReferenceManyField,
    SimpleForm,
    TextInput,
    //TabbedForm,
    FormTab,
    SaveButton,
    Toolbar,
    FileInput,
    FileField,
    ReferenceField,
    FunctionField,
    DateField,
    DateTimeInput,
    DateInput,
    Labeled,
    useTranslate,
    BooleanField,
    useEditContext,
    TextField,
    useRecordContext,
    useRefresh,
    useNotify,
    useExpanded,
    RecordContext,
    ArrayInput,
    SimpleFormIterator,
    FormDataConsumer,
    usePermissions,
    useResourceContext,
} from 'react-admin';
import { TabbedForm, useCanAccess } from '@react-admin/ra-rbac';
import {
    EditInDialogButton,
    CreateInDialogButton,
} from '@react-admin/ra-form-layout';
import {
    required,
    minValue,
    maxValue,
    minLength,
    maxLength,
    number,
    email,
    regex,
    choices,
} from 'react-admin';
import {
    Grid,
    Box,
    Typography,
    Stack,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    Chip,
    IconButton,
    Tooltip,
} from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { red, green } from '@mui/material/colors';
import { Business } from '@mui/icons-material';
import { StatsTooltip } from '../../../components/statistics/common';

import Merge from '../controls/Merge';
import CrmContactInfo from './CrmContactInfo';
import TeacherCacheStatus from './TeacherCacheStatus';

import {
    CustomSelectInput,
    CustomSelectArrayInput,
    CustomCheckboxGroupInput,
    CustomRadioButtonGroupInput,
    CustomJSONPretty,
    CustomTextField,
    CustomBulkDeleteButton,
    CustomBulkAddButton,
    CustomProductList,
    CustomNumberInput,
    CustomLogEventList,
    CustomUserLicenseByUserList,
    CustomUserSchoolList,
    CustomAutocompleteInput,
    CustomAddSubscriptionButton,
} from '../../controls';

import {
    LibraryBooks,
    Article,
    Podcasts,
    Attachment,
    DataObject,
    TransferWithinAStation,
    History,
    Computer,
    Source,
} from '@mui/icons-material';
import { Label } from 'recharts';

import { EditableDatagrid, RowForm } from '@react-admin/ra-editable-datagrid';
import RoleNameField from '../RoleNameField';
import SubjectListField from '../SubjectListField';
import CustomEmpty from '../../controls/CustomEmpty';
import GdprDelete from '../controls/GdprDelete';

import CustomStatistics from '../../controls/CustomStatistics';
import StatsWithIcon from '../../../components/statistics/controls/StatsWithIcon';
import SourceNameField from '../SourceNameField';
import SessionBadge from '../controls/SessionBadge';
import StaleBadge from '../controls/StaleBadge';
import ConditionalLoginField from '../ConditionalLoginField';
import ConditionalMergeField from '../ConditionalMergeField';
import {
    MailExample,
    SendMailApplication,
    SendMailLang,
} from '../CreateUserDialogButton';
import PasswordResetLink from '../PasswordResetLink';
import ValidityStatusBadge from '../ValidityStatusBadge';

const getLastSegment = (url: string): string => {
    const segments = url.split('/');
    return segments.pop() || '';
};

export const ValidateEmailUnicity = async (
    value: string,
    mustExist: boolean = false,
    userId?: string
) => {
    userId = userId ?? getLastSegment(window.location.href);
    console.log('userId', userId);
    console.log('ValidateEmailUnicity', value);
    console.log('value', value);
    console.log('mustExist', mustExist);

    if (email()(value) !== undefined) {
        return email()(value);
    }

    let api = `${
        process.env.REACT_APP_INFRA_API
    }/teacher?filter=${encodeURIComponent(
        JSON.stringify({
            q: value,
            need_count: false,
            wholeword: true,
            not_id: userId,
        })
    )}`;

    const response = await fetch(api, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    });

    const users = await response.json();
    const isEmailUnique = users.length === 0;

    if (!isEmailUnique && !mustExist) {
        // You can return a translation key as well
        return 'notifications.EMAIL_ALREADY_USED';

        // Or even an object just like the other validators

        /*
        return {
            message: 'myroot.validation.email_already_used',
            args: { email: value },
        };
        */
    } else if (isEmailUnique && mustExist) {
        return 'notifications.EMAIL_NOT_EXISTS';
    }
    return undefined;
};

const EditToolbar = ({ canWrite }: { canWrite?: boolean }) => {
    return (
        <Toolbar>
            {canWrite ? (
                <SaveButton />
            ) : (
                <Typography variant="body2" color="warning.main">
                    Sinulla ei ole muokkausoikeutta.
                </Typography>
            )}
        </Toolbar>
    );
};

const ApplicationForm = () => {
    const useEdit = useEditContext();
    //console.log('record', record);
    return (
        <RowForm defaultValues={{ user_guid: useEdit.record.guid }}>
            <CustomSelectInput
                resource="userapplication"
                source="application_guid"
                url="extralist/userapplication/applications"
                label=""
                validate={[required()]}
            />
            <BooleanInput
                resource="userapplication"
                source="isadmin"
                label=""
            />
            <CustomSelectInput
                resource="userapplication"
                source="public.userrights"
                url="extralist/userapplication/userrights"
                label=""
                showIfControl="application_guid"
                showIfValue="13b312b5-367c-4c74-bb77-bdb34df4e721"
                validate={[required()]}
            />
            <CustomSelectInput
                resource="userapplication"
                source="status"
                url="extralist/userapplication/statuses"
                label=""
                validate={[required()]}
            />
        </RowForm>
    );
};

// Edits a single school relation (role/status/dates/stale toggle) in a standalone dialog that
// fetches/saves directly against usergroup/{guid} - avoids the EditableDatagrid/RowForm inline
// editing machinery entirely (colSpan/row-alignment bugs that broke editing non-first rows).
const SchoolEditButton = ({
    onAfterSave,
    canWrite,
}: {
    onAfterSave: () => void;
    canWrite?: boolean | null;
}) => {
    const record = useRecordContext();
    const translate = useTranslate();
    if (!canWrite || !record?.usergroup_guid) return null;

    // Delayed to the next tick (after the dialog's own close transition/unmount) - calling the
    // (global, unfiltered) refresh() synchronously on success can invalidate the teacher record
    // feeding this very row while its dialog is still closing, yanking focus out from under it
    // mid-transition (-> "Blocked aria-hidden ... descendant retained focus" console warning,
    // and the save can appear to silently do nothing).
    const handleSaved = () => setTimeout(onAfterSave, 0);

    return (
        <EditInDialogButton
            resource="usergroup"
            id={record.usergroup_guid}
            title=" "
            maxWidth="sm"
            fullWidth
            // react-admin's default "undoable" mode optimistically updates the UI and only fires
            // the real PUT once the (skipped, since we override onSuccess below) undo toast times
            // out - which never happens here, so the write was silently never sent. Pessimistic
            // mode waits for the real server response before closing/refreshing.
            mutationMode="pessimistic"
            mutationOptions={{ onSuccess: handleSaved }}
        >
            {/* Default SaveButton stays disabled while the form isn't "dirty"; our status/role
                selects are lazily mounted by CustomSelectInput (null until choices load), which
                can leave react-hook-form's dirty tracking out of sync, so the button appears to
                do nothing when clicked. alwaysEnable bypasses that check. */}
            <SimpleForm
                toolbar={
                    <Toolbar>
                        <SaveButton alwaysEnable />
                    </Toolbar>
                }
            >
                <TextField resource="usergroup" source="group.name" label="" />
                <CustomSelectInput
                    resource="usergroup"
                    source="role_guid"
                    label={translate('resources.user.fields.group.role')}
                    url="extralist/teacher/roles"
                    validate={required()}
                />
                <FormDataConsumer>
                    {({ formData }) => {
                        return formData && formData?.role_guid ? (
                            <CustomSelectArrayInput
                                label="resources.teacher.fields.role.subjects"
                                resource="teacher"
                                source={`public.subject`}
                                optionText="name"
                                optionValue="guid"
                                url={`extralist/teacher/role/${formData?.role_guid}/subjects`}
                            />
                        ) : null;
                    }}
                </FormDataConsumer>
                <BooleanInput
                    resource="usergroup"
                    source="public.ofduty"
                    label={translate('resources.user.fields.group.ofduty')}
                />
                <BooleanInput
                    resource="usergroup"
                    source="public.isadmin"
                    label={translate('resources.user.fields.group.isadmin')}
                />
                <CustomSelectInput
                    resource="usergroup"
                    source="status"
                    label={translate('resources.user.fields.group.status')}
                    url="extralist/teacher/statuses"
                    validate={required()}
                />
                <DateInput
                    resource="usergroup"
                    source="public.validfrom"
                    label={translate(
                        'resources.teacher.fields.public.validfrom'
                    )}
                />
                <DateInput
                    resource="usergroup"
                    source="public.validto"
                    label={translate('resources.teacher.fields.public.validto')}
                />
                <StaleBadge
                    resource="usergroup"
                    options={{ showDetails: true, showToggle: true }}
                    onAfterAction={handleSaved}
                >
                    <span />
                </StaleBadge>
            </SimpleForm>
        </EditInDialogButton>
    );
};

// Adds a new school relation for the teacher - same field set as SchoolEditButton minus the
// read-only name/stale-badge, plus a school picker (group_guid, not editable afterwards).
const SchoolAddButton = ({
    onAfterSave,
    canWrite,
}: {
    onAfterSave: () => void;
    canWrite?: boolean | null;
}) => {
    const record = useRecordContext();
    const translate = useTranslate();
    if (!canWrite || !record?.guid) return null;

    return (
        <CreateInDialogButton
            resource="usergroup"
            title=" "
            label="resources.teacher.actions.add_school"
            maxWidth="sm"
            fullWidth
            mutationOptions={{ onSuccess: onAfterSave }}
        >
            <SimpleForm
                defaultValues={{ user_guid: record.guid }}
                toolbar={
                    <Toolbar>
                        <SaveButton alwaysEnable />
                    </Toolbar>
                }
            >
                <ReferenceInput
                    resource="usergroup"
                    source="group_guid"
                    reference="extralist/schools"
                >
                    <AutocompleteInput
                        source="group_guid"
                        optionText="item_title"
                        optionValue="item_id"
                        label={translate('resources.user.fields.group.name')}
                        validate={required()}
                        fullWidth
                    />
                </ReferenceInput>
                <CustomSelectInput
                    resource="usergroup"
                    source="role_guid"
                    label={translate('resources.user.fields.group.role')}
                    url="extralist/teacher/roles"
                    validate={required()}
                />
                <FormDataConsumer>
                    {({ formData }) => {
                        return formData && formData?.role_guid ? (
                            <CustomSelectArrayInput
                                label="resources.teacher.fields.role.subjects"
                                resource="teacher"
                                source={`public.subject`}
                                optionText="name"
                                optionValue="guid"
                                url={`extralist/teacher/role/${formData?.role_guid}/subjects`}
                            />
                        ) : null;
                    }}
                </FormDataConsumer>
                <BooleanInput
                    resource="usergroup"
                    source="public.ofduty"
                    label={translate('resources.user.fields.group.ofduty')}
                />
                <BooleanInput
                    resource="usergroup"
                    source="public.isadmin"
                    label={translate('resources.user.fields.group.isadmin')}
                />
                <CustomSelectInput
                    resource="usergroup"
                    source="status"
                    label={translate('resources.user.fields.group.status')}
                    url="extralist/teacher/statuses"
                    validate={required()}
                />
            </SimpleForm>
        </CreateInDialogButton>
    );
};

// Edits just the membership status (active/deleted) of one class relation - a single raw PUT,
// not a full dialog, since it's the only editable field here (class name links to the group
// instead; the class's own archived/deleted state is informational only, not editable here).
// Toggles a class membership between active/removed - mirrors the plus/minus IconButton
// convention used for school membership status in the teacher list (ChangeUserStatus.tsx),
// instead of a dropdown offering invitation-only statuses that don't apply to class rows.
const ClassStatusToggle = ({
    classRow,
    userGuid,
}: {
    classRow: any;
    userGuid: string;
}) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const translate = useTranslate();
    const [loading, setLoading] = React.useState(false);

    const setStatus = async (value: number) => {
        setLoading(true);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_INFRA_API}/usergroup/${classRow.usergroup_guid}`,
                {
                    method: 'PUT',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                    // SET_STATUS only touches the status column (backend action) - the plain
                    // field-update path would overwrite the whole info jsonb (public/private)
                    // with whatever partial shape we send here, wiping unrelated data.
                    body: JSON.stringify({
                        action: 'SET_STATUS',
                        user_guid: userGuid,
                        group_guid: classRow.guid,
                        status: value,
                    }),
                }
            );
            if (!res.ok) throw new Error('status update failed');
            notify('notifications.SAVE_SUCCESS', { type: 'success' });
            refresh();
        } catch (e) {
            notify('notifications.ACTION_ERROR', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    if (!classRow.usergroup_guid) {
        return (
            <ValidityStatusBadge
                record={classRow}
                statusSource="status"
                showAsText={true}
            />
        );
    }

    if (loading) {
        return <CircularProgress size={16} />;
    }

    return classRow.status === 0 ? (
        <Stack direction="row" spacing={0.5} alignItems="center">
            <IconButton
                size="small"
                title={translate(
                    'resources.teacher.actions.remove.button_title'
                )}
                onClick={() => setStatus(1)}
            >
                <RemoveCircleOutlineIcon
                    sx={{ color: red[500] }}
                    fontSize="inherit"
                />
            </IconButton>
            {translate('resources.user.status.0')}
        </Stack>
    ) : (
        <Stack direction="row" spacing={0.5} alignItems="center">
            <IconButton
                size="small"
                title={translate(
                    'resources.teacher.actions.unremove.button_title'
                )}
                onClick={() => setStatus(0)}
            >
                <AddCircleOutlineIcon
                    sx={{ color: green[500] }}
                    fontSize="inherit"
                />
            </IconButton>
            {translate('resources.user.status.1')}
        </Stack>
    );
};

// Shared active/archived-or-deleted predicate for a class relation - also used by
// SchoolsDatagrid's countClasses() to keep the expand panel and the "Ryhmät" column badge in sync.
const isActiveClass = (c: any) =>
    c.archived !== true && c.status === 0 && c.class_status === 0;

// Read-only - teaching groups/classes for one school, sourced from the teacher record's own
// `classes` array (already fetched by GET /teacher/{guid}, no separate usergroup fetch).
// Uses useEditContext() (not the ambient RecordContext, which Datagrid/ArrayField overrides
// per-row to the SCHOOL record) to reliably reach the TEACHER record regardless of nesting.
const SchoolClassesExpand = () => {
    const school = useRecordContext();
    const { record: teacher } = useEditContext();
    const translate = useTranslate();
    const [showArchived, setShowArchived] = React.useState(false);

    const schoolClasses = (teacher?.classes || []).filter(
        c => c.school_guid === school?.guid
    );
    const classes = showArchived
        ? schoolClasses
        : schoolClasses.filter(isActiveClass);

    return (
        <Box sx={{ p: 1 }}>
            <FormControlLabel
                control={
                    <Checkbox
                        size="small"
                        checked={showArchived}
                        onChange={e => setShowArchived(e.target.checked)}
                    />
                }
                label={translate('resources.user.fields.group.show_archived')}
            />
            {classes.length === 0 ? (
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ p: 2 }}
                >
                    {translate('resources.user.fields.group.no_classes')}
                </Typography>
            ) : (
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                {translate('resources.user.fields.group.name')}
                            </TableCell>
                            <TableCell>
                                {translate(
                                    'resources.user.fields.group.status'
                                )}
                            </TableCell>
                            <TableCell>
                                {translate(
                                    'resources.user.fields.group.joined'
                                )}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {classes.map(c => (
                            <TableRow key={c.guid}>
                                <TableCell>
                                    <Stack
                                        direction="row"
                                        spacing={0.5}
                                        alignItems="center"
                                    >
                                        <Link
                                            href={`#/group/${c.guid}`}
                                            onClick={e => e.stopPropagation()}
                                            underline="hover"
                                        >
                                            {c.name}
                                        </Link>
                                        {c.class_status !== 0 && (
                                            <Chip
                                                size="small"
                                                color="error"
                                                label={translate(
                                                    'resources.user.fields.group.deleted'
                                                )}
                                            />
                                        )}
                                        {c.archived === true && (
                                            <Chip
                                                size="small"
                                                color="error"
                                                label={translate(
                                                    'resources.user.fields.group.archived'
                                                )}
                                            />
                                        )}
                                    </Stack>
                                </TableCell>
                                <TableCell>
                                    <ClassStatusToggle
                                        classRow={c}
                                        userGuid={teacher?.guid}
                                    />
                                </TableCell>
                                <TableCell>
                                    {c.joined &&
                                        new Date(c.joined).toLocaleDateString(
                                            'fi-FI'
                                        )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Box>
    );
};

// Clickable count badges that also double as the expand trigger for a school's classes - uses
// the same useExpanded(resource, id, single) store Datagrid's own chevron writes to, so both
// stay in sync. Shows the active count, plus a separate outlined badge for archived/deleted
// classes when there are any. Plain text (no click handler) when there are no classes to show.
const ClassCountBadge = ({
    activeCount,
    archivedOrDeletedCount,
    resource,
    id,
}: {
    activeCount: number;
    archivedOrDeletedCount: number;
    resource: string;
    id: string;
}) => {
    const translate = useTranslate();
    const [, toggleExpanded] = useExpanded(resource, id, true);

    if (activeCount === 0 && archivedOrDeletedCount === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                0
            </Typography>
        );
    }

    const handleClick = e => {
        e.stopPropagation();
        toggleExpanded();
    };

    return (
        <Stack direction="row" spacing={0.5}>
            <Tooltip
                title={translate(
                    'resources.user.fields.group.active_classes_count'
                )}
            >
                <Chip
                    size="small"
                    clickable
                    label={activeCount}
                    onClick={handleClick}
                />
            </Tooltip>
            {archivedOrDeletedCount > 0 && (
                <Tooltip
                    title={translate(
                        'resources.user.fields.group.archived_or_deleted_classes_count'
                    )}
                >
                    <Chip
                        size="small"
                        clickable
                        variant="outlined"
                        color="error"
                        label={archivedOrDeletedCount}
                        onClick={handleClick}
                    />
                </Tooltip>
            )}
        </Stack>
    );
};

// Wraps the schools Datagrid so it can reach the teacher's own `classes` array via
// useEditContext() (see SchoolClassesExpand for why: the ambient RecordContext here is
// per-ROW/school, not the teacher - EditContext isn't shadowed the same way) to count classes
// per school for the "Ryhmät" column and to disable expansion entirely when there are none.
// `editColumn` (the "Muokkaa" button) is rendered last, after "Ryhmät", as its own prop rather
// than a regular child so "Ryhmät" always stays to its left regardless of the other columns.
const SchoolsDatagrid = ({
    children,
    editColumn,
}: {
    children: React.ReactNode;
    editColumn?: React.ReactNode;
}) => {
    const translate = useTranslate();
    const { record: teacher } = useEditContext();
    const resource = useResourceContext();

    const countClasses = (school: any) => {
        const schoolClasses = (teacher?.classes || []).filter(
            (c: any) => c.school_guid === school.guid
        );
        const active = schoolClasses.filter(isActiveClass).length;
        return {
            total: schoolClasses.length,
            active,
            archivedOrDeleted: schoolClasses.length - active,
        };
    };

    return (
        <Datagrid
            bulkActionButtons={false}
            expand={<SchoolClassesExpand />}
            expandSingle={true}
            isRowExpandable={record => countClasses(record).total > 0}
            rowClick={false}
        >
            {children}
            <FunctionField
                label={translate('resources.user.fields.group.classes_count')}
                render={record => {
                    const counts = countClasses(record);
                    return (
                        <ClassCountBadge
                            activeCount={counts.active}
                            archivedOrDeletedCount={counts.archivedOrDeleted}
                            resource={resource}
                            id={record.id}
                        />
                    );
                }}
            />
            {editColumn}
        </Datagrid>
    );
};

const TeacherEdit = () => {
    const translate = useTranslate();
    const record = useRecordContext();
    const resource = useResourceContext();
    const refresh = useRefresh();
    const { isLoading, canAccess } = useCanAccess({
        action: 'crm',
        resource: 'user',
        record,
    });
    const { canAccess: canWrite } = useCanAccess({ action: 'write', resource });
    const { canAccess: canManageMerges } = useCanAccess({
        action: 'read',
        resource: 'merge',
    });
    const { canAccess: canResetPassword } = useCanAccess({
        action: 'reset_password',
        resource,
    });
    const { canAccess: canAccessValkey } = useCanAccess({
        action: '*',
        resource: 'valkey',
    });

    const formatDate = dateString => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fi-FI', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
        });
    };

    return (
        <Edit
            redirect={false}
            mutationMode="optimistic"
            queryOptions={{ refetchOnMount: 'always' }}
        >
            <TabbedForm toolbar={<EditToolbar canWrite={canWrite} />}>
                <FormTab
                    label="resources.teacher.tabs.profile"
                    icon={<Article />}
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <TextInput
                                resource="teacher"
                                source="public.firstname"
                                validate={[required()]}
                                fullWidth
                            />
                            <TextInput
                                resource="teacher"
                                source="public.lastname"
                                validate={[required()]}
                                fullWidth
                            />
                            <TextInput
                                resource="teacher"
                                source="username"
                                fullWidth
                                validate={value => {
                                    return ValidateEmailUnicity(value);
                                }}
                            />

                            <TextInput
                                resource="teacher"
                                source="public.description"
                                fullWidth
                            />
                            <CustomSelectInput
                                resource="teacher"
                                source="status"
                                url="extralist/teacher/statuses"
                                parse={v => parseInt(v)}
                                fullWidth
                            />

                            {canResetPassword && <PasswordResetLink />}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                            {canWrite && (
                                <Box
                                    display={{ xs: 'block', sm: 'flex' }}
                                    justifyContent="flex-end"
                                >
                                    <GdprDelete />
                                </Box>
                            )}

                            <Typography variant="subtitle1">
                                {translate(
                                    'resources.teacher.fields.group.valid'
                                )}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary',
                                }}
                            >
                                {translate(
                                    'resources.teacher.fields.group.valid_desc'
                                )}
                            </Typography>
                            <Box display={{ xs: 'block', sm: 'flex' }}>
                                <DateInput
                                    resource="teacher"
                                    source="public.validfrom"
                                />
                            </Box>
                            <Box display={{ xs: 'block', sm: 'flex' }}>
                                <DateInput
                                    resource="teacher"
                                    source="public.validto"
                                />
                            </Box>

                            <BooleanInput
                                resource="teacher"
                                source="public.login_not_allowed"
                            />
                            <Stack direction="column">
                                <Stack direction="column">
                                    <BooleanInput
                                        resource="teacher"
                                        source="public.profile_locked"
                                    />
                                </Stack>
                                <Stack direction="row">
                                    <FormDataConsumer>
                                        {({ formData, scopedFormData }) => {
                                            return formData &&
                                                formData?.public
                                                    ?.profile_locked ? (
                                                <Stack direction="column">
                                                    <Stack
                                                        direction="row"
                                                        spacing={2}
                                                    >
                                                        <BooleanInput
                                                            resource="teacher"
                                                            label="resources.user.fields.public.profile_locked_message"
                                                            source="notification.profile_locked"
                                                        />

                                                        <FormDataConsumer>
                                                            {({
                                                                formData,
                                                                ...rest
                                                            }) =>
                                                                formData
                                                                    ?.notification
                                                                    ?.profile_locked ? (
                                                                    <>
                                                                        <SendMailLang source="notification.lang" />
                                                                        <SendMailApplication
                                                                            resource="teacher"
                                                                            source="notification.application"
                                                                            {...rest}
                                                                        />
                                                                    </>
                                                                ) : null
                                                            }
                                                        </FormDataConsumer>
                                                    </Stack>
                                                    <Stack direction="column">
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: 'text.secondary',
                                                            }}
                                                        >
                                                            {translate(
                                                                'resources.user.fields.public.profile_locked_description'
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                </Stack>
                                            ) : null;
                                        }}
                                    </FormDataConsumer>
                                </Stack>
                                <FormDataConsumer>
                                    {({ formData, ...rest }) =>
                                        formData?.notification
                                            ?.profile_locked &&
                                        formData?.notification?.lang &&
                                        formData?.notification?.application ? (
                                            <Stack
                                                direction="column"
                                                sx={{ marginTop: 2 }}
                                            >
                                                <MailExample
                                                    lang={
                                                        formData?.notification
                                                            ?.lang
                                                    }
                                                    application={
                                                        formData?.notification
                                                            ?.application || ''
                                                    }
                                                    status={formData.status}
                                                    mailtemplate="UNLOCK_PROFILE"
                                                    {...rest}
                                                />
                                            </Stack>
                                        ) : null
                                    }
                                </FormDataConsumer>
                            </Stack>
                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2, marginTop: 2 }}
                            >
                                <Labeled>
                                    <SessionBadge
                                        source="last_login"
                                        options={{
                                            showTTL: true,
                                            showSessionDelete: true,
                                        }}
                                    >
                                        <ConditionalLoginField
                                            resource="teacher"
                                            showTime
                                            locales="fi-FI"
                                        />
                                    </SessionBadge>
                                </Labeled>
                            </Box>

                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2 }}
                            >
                                <Labeled label="resources.user.stale.title">
                                    <StaleBadge
                                        options={{
                                            showDetails: true,
                                            showToggle: true,
                                        }}
                                    >
                                        <span />
                                    </StaleBadge>
                                </Labeled>
                            </Box>

                            {canAccessValkey && (
                                <Box
                                    display={{ xs: 'block', sm: 'flex' }}
                                    sx={{ marginBottom: 2 }}
                                >
                                    <TeacherCacheStatus />
                                </Box>
                            )}

                            <Box display={{ xs: 'block', sm: 'flex' }}>
                                <ConditionalMergeField />
                            </Box>

                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2 }}
                            >
                                <Labeled label="resources.teacher.fields.services">
                                    <SourceNameField
                                        showRemove={!!canWrite}
                                        showDebug={!!canWrite}
                                    />
                                </Labeled>
                            </Box>

                            <Stack direction="row" spacing={4}>
                                <Box>
                                    <Labeled label="resources.teacher.fields.author.creator">
                                        <>
                                            <ReferenceField
                                                reference="user"
                                                source="author.creator"
                                            >
                                                <FunctionField
                                                    render={record =>
                                                        `${record.public.firstname} ${record.public.lastname}`
                                                    }
                                                />
                                            </ReferenceField>
                                            <DateField
                                                resource="teacher"
                                                source="registered"
                                                showTime
                                                locales={'fi-FI'}
                                            />
                                        </>
                                    </Labeled>
                                </Box>
                                <Box>
                                    <Labeled label="resources.teacher.fields.author.modifier">
                                        <>
                                            <ReferenceField
                                                reference="user"
                                                source="author.modifier"
                                            >
                                                <FunctionField
                                                    render={record =>
                                                        `${record.public.firstname} ${record.public.lastname}`
                                                    }
                                                />
                                            </ReferenceField>
                                            <DateField
                                                resource="teacher"
                                                source="author.modified"
                                                showTime
                                                locales={'fi-FI'}
                                            />
                                        </>
                                    </Labeled>
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </FormTab>
                <TabbedForm.Tab
                    label="resources.user.tabs.application"
                    icon={<Computer />}
                    path="palvelut"
                    name="palvelut"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <ReferenceManyField
                                reference="userapplication"
                                target="user_guid"
                            >
                                <EditableDatagrid
                                    bulkActionButtons={false}
                                    createForm={
                                        canWrite ? (
                                            <ApplicationForm />
                                        ) : undefined
                                    }
                                    editForm={<ApplicationForm />}
                                    noDelete={!canWrite}
                                    actions={canWrite ? undefined : false}
                                >
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="application_guid"
                                        label={translate(
                                            'resources.user.fields.application.name'
                                        )}
                                        url="extralist/userapplication/applications"
                                        showAsText={true}
                                    />
                                    <BooleanField
                                        resource="userapplication"
                                        source="isadmin"
                                        label={translate(
                                            'resources.user.fields.application.isadmin'
                                        )}
                                    />
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="public.userrights"
                                        label={translate(
                                            'resources.user.fields.application.role'
                                        )}
                                        url="extralist/userapplication/userrights"
                                        showAsText={true}
                                    />
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="status"
                                        label={translate(
                                            'resources.user.fields.application.status'
                                        )}
                                        url="extralist/userapplication/statuses"
                                        showAsText={true}
                                    />
                                </EditableDatagrid>
                            </ReferenceManyField>
                        </Grid>
                    </Grid>
                </TabbedForm.Tab>
                <FormTab
                    label="resources.teacher.tabs.schools_and_groups"
                    icon={<LibraryBooks />}
                    path="koulut_ja_ryhmat"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mb: 1,
                                }}
                            >
                                <SchoolAddButton
                                    canWrite={canWrite}
                                    onAfterSave={refresh}
                                />
                            </Box>
                            <ArrayField
                                source="schools"
                                sort={{ field: 'name', order: 'ASC' }}
                            >
                                <SchoolsDatagrid
                                    editColumn={
                                        <SchoolEditButton
                                            canWrite={canWrite}
                                            onAfterSave={refresh}
                                        />
                                    }
                                >
                                    <FunctionField
                                        source="name"
                                        label={translate(
                                            'resources.user.fields.group.name'
                                        )}
                                        render={record => {
                                            return (
                                                <StatsTooltip
                                                    title={[
                                                        record?.author?.created
                                                            ? `Liitytty${record?.author?.mpass ? ' (MPASS)' : ''}: ${formatDate(record.author.created)}`
                                                            : null,
                                                        record?.author?.modified
                                                            ? `Muokattu: ${formatDate(record.author.modified)}`
                                                            : null,
                                                    ]
                                                        .filter(Boolean)
                                                        .join('\n')}
                                                    followCursor
                                                    placement="top-start"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                padding:
                                                                    '12px 16px',
                                                                fontSize:
                                                                    '14px',
                                                                lineHeight: 1.4,
                                                                whiteSpace:
                                                                    'pre-line',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <Link
                                                            sx={{
                                                                textDecoration:
                                                                    record.school_status ===
                                                                    1
                                                                        ? 'line-through'
                                                                        : 'none',
                                                                color:
                                                                    record.school_status ===
                                                                    0
                                                                        ? '#000'
                                                                        : 'red',
                                                                '&:hover': {
                                                                    textDecoration:
                                                                        'underline',
                                                                },
                                                            }}
                                                            href={`#/school/${record.guid}`}
                                                            onClick={e =>
                                                                e.stopPropagation()
                                                            }
                                                            underline="hover"
                                                        >
                                                            {record.name}
                                                        </Link>
                                                        {record?.services?.includes(
                                                            'opepalvelu'
                                                        ) && (
                                                            <span
                                                                style={{
                                                                    backgroundColor:
                                                                        '#afbec5',
                                                                    fontSize: 10,
                                                                    color: 'rgb(255, 255, 255)',
                                                                    padding:
                                                                        '1px 6px',
                                                                    borderRadius: 3,
                                                                    background:
                                                                        'rgba(96, 125, 139, 0.5)',
                                                                    height: 15,
                                                                    marginLeft: 3,
                                                                }}
                                                            >
                                                                OOP
                                                            </span>
                                                        )}
                                                        {record?.services?.includes(
                                                            'finnlectura'
                                                        ) && (
                                                            <span
                                                                style={{
                                                                    backgroundColor:
                                                                        '#afbec5',
                                                                    fontSize: 10,
                                                                    color: 'rgb(255, 255, 255)',
                                                                    padding:
                                                                        '1px 6px',
                                                                    borderRadius: 3,
                                                                    background:
                                                                        'rgba(96, 125, 139, 0.5)',
                                                                    height: 15,
                                                                    marginLeft: 3,
                                                                }}
                                                            >
                                                                FL
                                                            </span>
                                                        )}
                                                        {record?.services?.includes(
                                                            'crm'
                                                        ) && (
                                                            <span
                                                                style={{
                                                                    backgroundColor:
                                                                        '#afbec5',
                                                                    fontSize: 10,
                                                                    color: 'rgb(255, 255, 255)',
                                                                    padding:
                                                                        '1px 6px',
                                                                    borderRadius: 3,
                                                                    background:
                                                                        'rgba(96, 125, 139, 0.5)',
                                                                    height: 15,
                                                                    marginLeft: 3,
                                                                }}
                                                            >
                                                                CRM
                                                            </span>
                                                        )}
                                                        {record?.author
                                                            ?.mpass && (
                                                            <span
                                                                style={{
                                                                    backgroundColor:
                                                                        '#afbec5',
                                                                    fontSize: 10,
                                                                    color: 'rgb(255, 255, 255)',
                                                                    padding:
                                                                        '1px 6px',
                                                                    borderRadius: 3,
                                                                    background:
                                                                        'rgba(76, 60, 196, 0.6)',
                                                                    height: 15,
                                                                    marginLeft: 3,
                                                                }}
                                                            >
                                                                MPASS
                                                            </span>
                                                        )}
                                                    </span>
                                                </StatsTooltip>
                                            );
                                        }}
                                    />

                                    <TextField
                                        source="role"
                                        label={translate(
                                            'resources.user.fields.group.role'
                                        )}
                                    />

                                    <SubjectListField
                                        label={translate(
                                            'resources.userlist.fields.subjects'
                                        )}
                                    />

                                    <BooleanField
                                        source="public.ofduty"
                                        label={translate(
                                            'resources.user.fields.group.ofduty'
                                        )}
                                        defaultValue="false"
                                    />
                                    <BooleanField
                                        source="public.isadmin"
                                        label={translate(
                                            'resources.user.fields.group.isadmin'
                                        )}
                                    />
                                    <ValidityStatusBadge
                                        statusSource="status"
                                        label={translate(
                                            'resources.user.fields.group.status'
                                        )}
                                        showAsText={true}
                                    />
                                    <DateField
                                        source="joined"
                                        locales="fi-FI"
                                        label={translate(
                                            'resources.user.fields.group.joined'
                                        )}
                                    />
                                    <StaleBadge
                                        resource="usergroup"
                                        options={{ showDetails: true }}
                                    >
                                        <span />
                                    </StaleBadge>
                                </SchoolsDatagrid>
                            </ArrayField>
                        </Grid>
                    </Grid>
                </FormTab>
                <FormTab
                    label="resources.teacher.tabs.materials"
                    icon={<LibraryBooks />}
                    path="kaytossa"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        {canWrite && (
                            <Grid size={12}>
                                <Typography variant="h5" paragraph>
                                    Lisää tilaus
                                </Typography>
                                <CustomProductList
                                    resource="product"
                                    disableSyncWithLocation
                                    storeKey={false}
                                    customFilters={[
                                        'use_query_min_length',
                                        'use_v2',
                                    ]}
                                    showExtra={['search', 'info']}
                                    sort={{ field: 'name', order: 'ASC' }}
                                    bulkActionButtons={
                                        <CustomAddSubscriptionButton />
                                    }
                                >
                                    <span />
                                </CustomProductList>
                            </Grid>
                        )}

                        <Grid size={12}>
                            <CustomUserLicenseByUserList
                                resource="userlicense"
                                disableSyncWithLocation
                                customFilters={['user_guid']}
                                showExtra={['seasonFilter']}
                                hideFields={[]}
                                sort={{ field: 'product.name', order: 'ASC' }}
                                bulkActionButtons={
                                    canWrite ? (
                                        <CustomBulkDeleteButton />
                                    ) : (
                                        false
                                    )
                                }
                            >
                                <span />
                            </CustomUserLicenseByUserList>
                        </Grid>
                    </Grid>
                </FormTab>
                {canManageMerges && (
                    <FormTab
                        label="resources.teacher.tabs.merge"
                        icon={<LibraryBooks />}
                        path="yhdistaminen"
                    >
                        <Grid container width={{ xs: '100%' }} spacing={2}>
                            <Grid size={12}>
                                <Merge />
                            </Grid>
                        </Grid>
                    </FormTab>
                )}
                {process.env.REACT_APP_CRM_TAB_ENABLED === 'true' &&
                    !isLoading &&
                    canAccess &&
                    canWrite && (
                        <FormTab
                            label="resources.teacher.tabs.crm"
                            icon={<Business />}
                            path="crm"
                        >
                            <Grid container width={{ xs: '100%' }} spacing={2}>
                                <Grid size={12}>
                                    <CrmContactInfo />
                                </Grid>
                            </Grid>
                        </FormTab>
                    )}
                <FormTab
                    label="resources.teacher.tabs.logs"
                    icon={<History />}
                    path="logit"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <CustomStatistics
                                statisticKey="userEvents"
                                handler={StatsWithIcon}
                                mode="List"
                                from="30d"
                                limit={30}
                                exclude_search={[
                                    'updateAspaProfile',
                                    'FORCE_LOGOUT',
                                ]}
                                include_search={[]}
                                pagination={true}
                                showFilter={true}
                                include_source_fields={[
                                    'infra2.request_detail',
                                ]}
                            />
                        </Grid>
                    </Grid>
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

const redirect: any = () => {
    return window.location.hash.replace('#', '');
};

export default TeacherEdit;
